import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_px8ok5q0jdway2 as get_px,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_unpadded3gipn3ftxgnwh as get_unpadded,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow } from '../../../nav/crowpay.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { space2ppi73m2qk1br as space } from '../../../space.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  divkhq3vjih9fcw as div,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { get_dragHandlemufcu3tsewag as get_dragHandle } from '../../../../../icons.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  weightt34o7llf2uyq as weight,
  shownWhenxgf1ujy6rmvr as shownWhen,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import {
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../../../theming/Titles.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  concernsLegendInfoBubble92oj457wdret as concernsLegendInfoBubble,
  unreadIconVisibley9o01zmxr3gz as unreadIconVisible,
  actionIcon360epyywhabwj as actionIcon,
  escalationIconVisiblevpqputebznaz as escalationIconVisible,
  timerRunningIconVisible3suc918cgfqrp as timerRunningIconVisible,
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
  escalationIconmtio0lqe8r8o as escalationIcon,
  timerRunningIcon3mra8cwh7awq2 as timerRunningIcon,
} from '../../../iconShortcuts.mjs';
import { get_expandButtonTheme1dpdnzsv2lxs8 as get_expandButtonTheme } from '../../../../theming/buttons.mjs';
import { SectionSemantic_getInstance27qbv8tkwzf0w as SectionSemantic_getInstance } from '../../../../theming/sections.mjs';
import { get_withoutPadding21hnjxk91b1qc as get_withoutPadding } from '../../../../theming/appTheme.mjs';
import {
  dynamicThemexp3sdnaolntz as dynamicTheme,
  get_compact3lsezez8nz8b6 as get_compact,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  DragShadowu6jlihuvhlhp as DragShadow,
  maxOfNotNullOrNull2k16vysnptiyz as maxOfNotNullOrNull,
  percentComplete22ixcedvdan2 as percentComplete,
  renderPercent3ullukkakwyrl as renderPercent,
} from '../../../../../utils/utils.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  expandIcon1as9er6lyg7in as expandIcon,
  expandAndMarkAsReadAction24de04tkd12ld as expandAndMarkAsReadAction,
} from '../../../expansion.mjs';
import { requiresAction13nb01xm2r5gu as requiresAction } from '../../../../../extensions/FlowPermissions.ext.mjs';
import { RequestComplete2fbpvksxlxjbf as RequestComplete } from '../../../../../../../../crowpay-shared/com/crowpay/completionResponse/CompletionResponse.mjs';
import { isFinal1ds8cwv2a0e8r as isFinal } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { ActionImportance_Important_getInstance3s7qtcym9r8wq as ActionImportance_Important_getInstance } from '../../../../screens/common/ProjectView.mjs';
import {
  StrikeThroughSemantic_getInstance2noty866j55zj as StrikeThroughSemantic_getInstance,
  LineItemStateSemantic242xtb5m8w8mc as LineItemStateSemantic,
} from '../../../../theming/states.mjs';
import {
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { priceWithChangedayxt0y21soj as priceWithChange } from '../../../priceChanges.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../../../theming/colorManagement.mjs';
import { compareTo3ankvs086tmwq as compareTo } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/compareTo.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { get_waitForNotNull1jl9mx6el51tq as get_waitForNotNull } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { displayState3t6e3fm84zv10 as displayState } from '../../../../../extensions/LineItem.ext.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var WorkItemWeightsClass;
function WorkItemWeights() {
  if (WorkItemWeightsClass === VOID) {
    class $ {
      constructor(narrow, reordering) {
        narrow = narrow === VOID ? false : narrow;
        reordering = reordering === VOID ? false : reordering;
        this.qhx_1 = narrow;
        this.rhx_1 = reordering;
        var tmp = this;
        // Inline function 'kotlin.let' call
        var it = this.qhx_1 ? 4.0 : 5.5;
        tmp.shx_1 = this.rhx_1 ? it - 0.6 : it;
        this.thx_1 = 1.2;
        this.uhx_1 = 1.2;
        this.vhx_1 = 1.3;
        this.whx_1 = 0.7;
        this.xhx_1 = get_rem(1);
      }
      yhx() {
        return this.thx_1 + this.uhx_1 + this.vhx_1 + this.whx_1;
      }
      toString() {
        return 'WorkItemWeights(narrow=' + this.qhx_1 + ', reordering=' + this.rhx_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.qhx_1);
        result = imul(result, 31) + getBooleanHashCode(this.rhx_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WorkItemWeights()))
          return false;
        if (!(this.qhx_1 === other.qhx_1))
          return false;
        if (!(this.rhx_1 === other.rhx_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'WorkItemWeights', WorkItemWeights);
    WorkItemWeightsClass = $;
  }
  return WorkItemWeightsClass;
}
function workItemTableHeader(_this__u8e3s4, showNameHeader, reordering) {
  reordering = reordering === VOID ? false : reordering;
  var tmp = sizeConstraints(_this__u8e3s4, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  view.zbm(false);
  var weights = new (WorkItemWeights())(get_viewIsNarrow(view), reordering);
  view.bb9(get_px(0));
  space(view, get_AppDimensions().zg1_1);
  if (reordering) {
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (IconView())(view.pc());
    var tmp0_elvis_lhs_0 = view.ebb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.gbb(p_0, view_0);
    var tmp0_vertical = get_px(0);
    var tmp1_horizontal = div(view_0.mba().jb0_1, 2);
    view_0.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
    view_0.gbu('drag');
    view_0.sbt(get_dragHandle(Companion_getInstance()));
    view_0.zb8(false);
    view.hbb(p_0, view_0);
  }
  var tmp_0 = get_expanding(view);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_1 = view.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
  view.gbb(p_1, view_1);
  view_1.zbm(false);
  view_1.bb9(weights.xhx_1);
  if (showNameHeader) {
    var tmp_1 = weight(view_1, weights.shx_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (RowOrCol())(view_1.pc());
    var tmp0_elvis_lhs_2 = view_1.ebb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
    view_1.gbb(p_2, view_2);
    view_2.zbm(false);
    view_2.bb9(get_AppDimensions().lg2_1);
    view_2.lbb(get_centered(view_2), bodyBold(view_2, 'Work Item'));
    view_1.hbb(p_2, view_2);
    view_1.lbb(tmp_1, view_2);
  } else {
    var tmp_2 = weight(view_1, weights.shx_1);
    // Inline function 'com.lightningkite.kiteui.views.direct.space' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (Space())(view_1.pc());
    var tmp0_elvis_lhs_3 = view_1.ebb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
    view_1.gbb(p_3, view_3);
    view_1.hbb(p_3, view_3);
    view_1.lbb(tmp_2, view_3);
  }
  var tmp_3 = view_1.kbb(weight(view_1, weights.thx_1), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_4 = view_1.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_1 : tmp0_elvis_lhs_4;
  view_1.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_4.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_4 = view_4.vb5_1;
  var tmp_5;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Amount') === 0) {
    tmp_5 = '\xA0';
  } else {
    tmp_5 = 'Amount';
  }
  tmp_4.hbu(tmp_5);
  view_1.hbb(p_4, view_4);
  view_1.lbb(tmp_3, view_4);
  var tmp_6 = view_1.kbb(weight(view_1, weights.uhx_1), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_5 = view_1.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
  view_1.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_5.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = '% Complete';
  var tmp_7 = view_5.vb5_1;
  var tmp_8;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_8 = '\xA0';
  } else {
    tmp_8 = value;
  }
  tmp_7.hbu(tmp_8);
  view_1.hbb(p_5, view_5);
  view_1.lbb(tmp_6, view_5);
  var tmp_9 = view_1.kbb(weight(view_1, weights.vhx_1), get_centered(view_1));
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_1.pc());
  var tmp0_elvis_lhs_6 = view_1.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_1 : tmp0_elvis_lhs_6;
  view_1.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(BodySemantic_getInstance().abf(BoldSemantic_getInstance())));
  view_6.dbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var tmp_10 = view_6.vb5_1;
  var tmp_11;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength('Status') === 0) {
    tmp_11 = '\xA0';
  } else {
    tmp_11 = 'Status';
  }
  tmp_10.hbu(tmp_11);
  view_1.hbb(p_6, view_6);
  view_1.lbb(tmp_9, view_6);
  var tmp_12 = weight(view_1, weights.whx_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view_1.pc());
  var tmp0_elvis_lhs_7 = view_1.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_1 : tmp0_elvis_lhs_7;
  view_1.gbb(p_7, view_7);
  view_7.lbb(get_centered(view_7), concernsLegendInfoBubble(view_7));
  view_1.hbb(p_7, view_7);
  view_1.lbb(tmp_12, view_7);
  view.hbb(p_1, view_1);
  view.lbb(tmp_0, view_1);
  _this__u8e3s4.hbb(p, view);
  return _this__u8e3s4.lbb(tmp, view);
}
function workItemTableRow(_this__u8e3s4, expanded, item, writer, unread, topLevel, dragData) {
  topLevel = topLevel === VOID ? true : topLevel;
  dragData = dragData === VOID ? null : dragData;
  // Inline function 'kotlin.with' call
  get_expandButtonTheme(writer);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(false);
  var $this$row = view;
  $this$row.bb9(get_px(0));
  if (topLevel) {
    dynamicTheme($this$row, ($this$dynamicTheme) => $this$dynamicTheme.daj(expanded) ? get_withoutPadding(SectionSemantic_getInstance()) : null);
  }
  var tmp = sizeConstraints($this$row, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().zg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (Frame())($this$row.pc());
  var tmp0_elvis_lhs_0 = $this$row.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? $this$row : tmp0_elvis_lhs_0;
  $this$row.gbb(p_0, view_0);
  get_centered(view_0);
  unreadIconVisible(view_0, ($this$unreadIconVisible) => $this$unreadIconVisible.daj($this$unreadIconVisible.daj(unread)));
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
  Companion_getInstance_0();
  $this$row.hbb(p_0, view_0);
  $this$row.lbb(tmp, view_0);
  if (!(dragData == null)) {
    var tmp_0 = get_centered($this$row);
    // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_1 = new (IconView())($this$row.pc());
    var tmp0_elvis_lhs_1 = $this$row.ebb_1;
    var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
    $this$row.gbb(p_1, view_1);
    var tmp0_vertical = get_px(0);
    var tmp1_horizontal = div(view_1.mba().jb0_1, 2);
    view_1.jba(Edges().ed0(tmp1_horizontal, tmp0_vertical));
    view_1.gbu('drag');
    view_1.sbt(get_dragHandle(Companion_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = IconView$_get_dragData_$ref_4jg2ny(view_1);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('dragData', 0, tmp_1, tmp_2, IconView$_set_dragData_$ref_k36t82(view_1));
    reactiveScope(view_1, ($this$reactiveScope) => {
      var tmp$ret$4 = $this$reactiveScope.daj(dragData).hcy(VOID, VOID, DragShadow($this$row, Align_Start_getInstance(), Align_Start_getInstance()));
      this_0.set(tmp$ret$4);
      return Unit_instance;
    });
    $this$row.hbb(p_1, view_1);
    $this$row.lbb(tmp_0, view_1);
  }
  var tmp_3 = $this$row.kbb(get_expanding($this$row), get_unpadded($this$row));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Button())($this$row.pc());
  var tmp0_elvis_lhs_2 = $this$row.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
  $this$row.gbb(p_2, view_2);
  var tmp_4 = sizeConstraints(view_2, VOID, VOID, VOID, VOID, VOID, VOID, get_rem(3));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (RowOrCol())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.gbb(p_3, view_3);
  view_3.zbm(false);
  var weights = new (WorkItemWeights())(get_viewIsNarrow(view_3), !(dragData == null));
  view_3.bb9(weights.xhx_1);
  var tmp_5 = weight(view_3, weights.shx_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (RowOrCol())(view_3.pc());
  var tmp0_elvis_lhs_4 = view_3.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
  view_3.gbb(p_4, view_4);
  view_4.zbm(false);
  view_4.bb9(get_AppDimensions().og2_1);
  view_4.lbb(get_centered(view_4), expandIcon(view_4, expanded));
  var tmp_6 = get_centered(view_4);
  view_4.lbb(tmp_6, actionIcon(view_4, VOID, ($this$actionIcon) => {
    var line = $this$actionIcon.daj(item);
    var tmp;
    if (!(line.g99() == null)) {
      return null;
    }
    var perms = $this$actionIcon.daj(_this__u8e3s4.ogf()).p3(line.mf9_1);
    var tmp_0 = perms == null ? null : requiresAction(perms);
    var tmp_1;
    var tmp_2;
    var tmp_3;
    if (_this__u8e3s4.tgj().zgj()) {
      var tmp2_safe_receiver = perms == null ? null : perms.v8w();
      var tmp_4 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d8w();
      tmp_3 = tmp_4 instanceof RequestComplete();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp_2 = !isFinal(line.mfy());
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      tmp_1 = ActionImportance_Important_getInstance();
    } else {
      tmp_1 = null;
    }
    return maxOfNotNullOrNull([tmp_0, tmp_1]);
  }));
  var tmp_7 = get_centered(view_4);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_5 = view_4.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
  view_4.gbb(p_5, view_5);
  view_5.lba(view_5.qb6_1.abf(BodySemantic_getInstance()));
  dynamicTheme(view_5, ($this$dynamicTheme) => $this$dynamicTheme.daj(item).qf9_1 ? StrikeThroughSemantic_getInstance() : null);
  var tmp_8 = KMutableProperty0();
  var tmp_9 = TextView$_get_content_$ref_4pzcwl(view_5);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_8, tmp_9, TextView$_set_content_$ref_pketfb(view_5));
  reactiveScope(view_5, ($this$reactiveScope) => {
    var tmp$ret$9 = $this$reactiveScope.daj(item).nf9_1;
    this_1.set(tmp$ret$9);
    return Unit_instance;
  });
  view_4.hbb(p_5, view_5);
  view_4.lbb(tmp_7, view_5);
  var tmp_10 = get_centered(view_4);
  // Inline function 'com.crowpay.views.theming.smallBody' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (TextView())(view_4.pc());
  var tmp0_elvis_lhs_6 = view_4.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
  view_4.gbb(p_6, view_6);
  view_6.lba(view_6.qb6_1.abf(SmallBodySemantic_getInstance()));
  var tmp_11 = KMutableProperty0();
  var tmp_12 = TextView$_get_content_$ref_4pzcwl_0(view_6);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_11, tmp_12, TextView$_set_content_$ref_pketfb_0(view_6));
  reactiveScope(view_6, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(item).b95();
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.h95_1;
    var tmp$ret$16 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_2.set(tmp$ret$16);
    return Unit_instance;
  });
  view_4.hbb(p_6, view_6);
  view_4.lbb(tmp_10, view_6);
  view_3.hbb(p_4, view_4);
  view_3.lbb(tmp_5, view_4);
  var tmp_13 = view_3.kbb(weight(view_3, weights.thx_1), get_centered(view_3));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_7 = new (Frame())(view_3.pc());
  var tmp0_elvis_lhs_7 = view_3.ebb_1;
  var p_7 = tmp0_elvis_lhs_7 == null ? view_3 : tmp0_elvis_lhs_7;
  view_3.gbb(p_7, view_7);
  var tmp_14 = get_centered(view_7);
  var tmp_15 = ($this$priceWithChange) => new (MonetaryValue())($this$priceWithChange.daj(item).jf9_1.d6l_1);
  view_7.lbb(tmp_14, priceWithChange(view_7, VOID, tmp_15, ($this$priceWithChange) => {
    // Inline function 'kotlin.let' call
    var it = $this$priceWithChange.daj(item).jf9_1;
    var tmp$ret$28 = MonetaryValue__minus_impl_jw9qyp(it.d6l_1, it.l6k_1);
    return new (MonetaryValue())(tmp$ret$28);
  }));
  view_3.hbb(p_7, view_7);
  view_3.lbb(tmp_13, view_7);
  var paid = remember(VOID, VOID, VOID, ($this$remember) => {
    var line = $this$remember.daj(item);
    var tmp;
    if (!(line.ofy() == null)) {
      return new (MonetaryValue())(line.jf9_1.d6l_1);
    }
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = $this$remember.daj(_this__u8e3s4.jgt());
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList().w();
    var _iterator__ex2g4s = tmp0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (element.q6v_1.equals(line.mf9_1) && (element.z6v_1 || element.x6v_1 === true)) {
        destination.v(element);
      }
    }
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s_0 = destination.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      var tmp_0 = sum;
      var tmp$ret$35 = element_0.r6v_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp_0, tmp$ret$35);
    }
    var tmp$ret$36 = sum;
    return new (MonetaryValue())(tmp$ret$36);
  });
  var tmp_16 = view_3.kbb(weight(view_3, weights.uhx_1), get_centered(view_3));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_8 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_8 = view_3.ebb_1;
  var p_8 = tmp0_elvis_lhs_8 == null ? view_3 : tmp0_elvis_lhs_8;
  view_3.gbb(p_8, view_8);
  view_8.lba(view_8.qb6_1.abf(BodySemantic_getInstance()));
  view_8.dbs(Align_Center_getInstance());
  var tmp_17 = KMutableProperty0();
  var tmp_18 = TextView$_get_content_$ref_4pzcwl_1(view_8);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('content', 0, tmp_17, tmp_18, TextView$_set_content_$ref_pketfb_1(view_8));
  reactiveScope(view_8, ($this$reactiveScope) => {
    var price = $this$reactiveScope.daj(item).jf9_1.d6l_1;
    var tmp$ret$37 = renderPercent(percentComplete($this$reactiveScope.daj(paid).y5r_1, price));
    this_3.set(tmp$ret$37);
    return Unit_instance;
  });
  view_3.hbb(p_8, view_8);
  view_3.lbb(tmp_16, view_8);
  var tmp_19 = view_3.kbb(weight(view_3, weights.vhx_1), get_centered(view_3));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_9 = new (TextView())(view_3.pc());
  var tmp0_elvis_lhs_9 = view_3.ebb_1;
  var p_9 = tmp0_elvis_lhs_9 == null ? view_3 : tmp0_elvis_lhs_9;
  view_3.gbb(p_9, view_9);
  view_9.lba(view_9.qb6_1.abf(BodySemantic_getInstance()));
  dynamicTheme(view_9, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = workItemTableRow$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$status_obexfr($this$dynamicTheme.daj(item));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = LineItemStateSemantic(tmp0_safe_receiver);
    }
    return tmp;
  });
  view_9.dbs(Align_Center_getInstance());
  var tmp_20 = KMutableProperty0();
  var tmp_21 = TextView$_get_content_$ref_4pzcwl_2(view_9);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_4 = getPropertyCallableRef('content', 0, tmp_20, tmp_21, TextView$_set_content_$ref_pketfb_2(view_9));
  reactiveScope(view_9, ($this$reactiveScope) => {
    var tmp0_safe_receiver = workItemTableRow$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$status_obexfr($this$reactiveScope.daj(item));
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l9b_1;
    var tmp$ret$46 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_4.set(tmp$ret$46);
    return Unit_instance;
  });
  view_3.hbb(p_9, view_9);
  view_3.lbb(tmp_19, view_9);
  var tmp_22 = weight(view_3, weights.whx_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_10 = new (Frame())(view_3.pc());
  var tmp0_elvis_lhs_10 = view_3.ebb_1;
  var p_10 = tmp0_elvis_lhs_10 == null ? view_3 : tmp0_elvis_lhs_10;
  view_3.gbb(p_10, view_10);
  var tmp_23 = get_centered(view_10);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_11 = new (RowOrCol())(view_10.pc());
  var tmp0_elvis_lhs_11 = view_10.ebb_1;
  var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
  view_10.gbb(p_11, view_11);
  view_11.zbm(false);
  var tmp_24 = get_centered(view_11);
  view_11.lbb(tmp_24, escalationIconVisible(view_11, remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.daj(_this__u8e3s4.ogf()).p3($this$remember.daj(item).mf9_1);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l8w();
  })));
  view_11.lbb(get_centered(view_11), timerRunningIconVisible(_this__u8e3s4, view_11, item));
  view_10.hbb(p_11, view_11);
  view_10.lbb(tmp_23, view_11);
  view_3.hbb(p_10, view_10);
  view_3.lbb(tmp_22, view_10);
  view_2.hbb(p_3, view_3);
  view_2.lbb(tmp_4, view_3);
  view_2.obg(expandAndMarkAsReadAction(view_2, expanded, unread));
  $this$row.hbb(p_2, view_2);
  $this$row.lbb(tmp_3, view_2);
  writer.hbb(p, view);
  return view;
}
function workItemTableSummary(_this__u8e3s4, items, scopeView, reordering, writer) {
  // Inline function 'kotlin.with' call
  var tmp = sizeConstraints(writer, VOID, VOID, VOID, VOID, VOID, VOID, get_rem_0(3.5));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(writer.pc());
  var tmp0_elvis_lhs = writer.ebb_1;
  var p = tmp0_elvis_lhs == null ? writer : tmp0_elvis_lhs;
  writer.gbb(p, view);
  view.zbm(false);
  var weights = new (WorkItemWeights())(get_viewIsNarrow(view), reordering);
  view.bb9(weights.xhx_1);
  space(view, get_AppDimensions().zg1_1);
  if (reordering) {
    space(view, get_dragHandle(Companion_getInstance()).tbt_1);
  }
  view.dbn(get_px(0));
  var tmp_0 = view.kbb(weight(view, weights.shx_1), get_compact(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.ebb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.gbb(p_0, view_0);
  view_0.zbm(false);
  var tmp_1 = view_0.kbb(colored(view_0, AppColors_getInstance().ffz_1.zg9_1), get_centered(view_0));
  var tmp_2 = get_rem_0(1.5);
  view_0.lbb(tmp_1, scopeSetIcon(view_0, tmp_2, ($this$scopeSetIcon) => {
    var tmp = KMutableProperty0();
    var tmp_0 = IconView$_get_shown_$ref_js8irt($this$scopeSetIcon);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_0 = getPropertyCallableRef('shown', 0, tmp, tmp_0, IconView$_set_shown_$ref_9ilxmr($this$scopeSetIcon));
    reactiveScope($this$scopeSetIcon, ($this$reactiveScope) => {
      var tmp$ret$0 = $this$reactiveScope.daj(scopeView).g99();
      this_0.set(tmp$ret$0);
      return Unit_instance;
    });
    return Unit_instance;
  }));
  var tmp_3 = get_centered(view_0);
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.ebb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.gbb(p_1, view_1);
  view_1.lba(view_1.qb6_1.abf(BodySemantic_getInstance()));
  var tmp_4 = KMutableProperty0();
  var tmp_5 = TextView$_get_content_$ref_4pzcwl_3(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb_3(view_1));
  reactiveScope(view_1, ($this$reactiveScope) => {
    var tmp$ret$2 = $this$reactiveScope.daj(scopeView).g99() ? 'Work Set Summary' : 'Work View Summary';
    this_0.set(tmp$ret$2);
    return Unit_instance;
  });
  view_0.hbb(p_1, view_1);
  view_0.lbb(tmp_3, view_1);
  view.hbb(p_0, view_0);
  view.lbb(tmp_0, view_0);
  var tmp_6 = view.kbb(weight(view, weights.thx_1), get_centered(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_2 = view.ebb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.gbb(p_2, view_2);
  var tmp_7 = get_centered(view_2);
  var tmp_8 = ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.daj(items);
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$13 = element.jf9_1.d6l_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$13);
    }
    var tmp$ret$14 = sum;
    return new (MonetaryValue())(tmp$ret$14);
  };
  view_2.lbb(tmp_7, priceWithChange(view_2, VOID, tmp_8, ($this$priceWithChange) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$priceWithChange.daj(items);
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$15 = MonetaryValue__minus_impl_jw9qyp(element.jf9_1.d6l_1, element.jf9_1.l6k_1);
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$15);
    }
    var tmp$ret$16 = sum;
    return new (MonetaryValue())(tmp$ret$16);
  }));
  view.hbb(p_2, view_2);
  view.lbb(tmp_6, view_2);
  var paid = remember(VOID, VOID, VOID, ($this$remember) => {
    var lines = $this$remember.daj(items);
    var draws = $this$remember.daj(_this__u8e3s4.jgt());
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = lines.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp_0;
      if (!(element.ofy() == null)) {
        tmp_0 = element.jf9_1.d6l_1;
      } else {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination = ArrayList().w();
        var _iterator__ex2g4s_0 = draws.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          if (element_0.q6v_1.equals(element.mf9_1) && (element_0.z6v_1 || element_0.x6v_1 === true)) {
            destination.v(element_0);
          }
        }
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum_0 = Companion_instance.r91(0n);
        var _iterator__ex2g4s_1 = destination.m1();
        while (_iterator__ex2g4s_1.n1()) {
          var element_1 = _iterator__ex2g4s_1.o1();
          var tmp_1 = sum_0;
          var tmp$ret$23 = element_1.r6v_1;
          sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_1, tmp$ret$23);
        }
        tmp_0 = sum_0;
      }
      var tmp$ret$25 = tmp_0;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$25);
    }
    var tmp$ret$26 = sum;
    return new (MonetaryValue())(tmp$ret$26);
  });
  var tmp_9 = view.kbb(weight(view, weights.uhx_1), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_3 = view.ebb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.gbb(p_3, view_3);
  view_3.lba(view_3.qb6_1.abf(BodySemantic_getInstance()));
  view_3.dbs(Align_Center_getInstance());
  var tmp_10 = KMutableProperty0();
  var tmp_11 = TextView$_get_content_$ref_4pzcwl_4(view_3);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('content', 0, tmp_10, tmp_11, TextView$_set_content_$ref_pketfb_4(view_3));
  reactiveScope(view_3, ($this$reactiveScope) => {
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_0 = $this$reactiveScope.daj(items);
    var sum = Companion_instance.r91(0n);
    var _iterator__ex2g4s = this_0.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp = sum;
      var tmp$ret$27 = element.jf9_1.d6l_1;
      sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$27);
    }
    var price = sum;
    var tmp$ret$29 = renderPercent(percentComplete($this$reactiveScope.daj(paid).y5r_1, price), 0);
    this_1.set(tmp$ret$29);
    return Unit_instance;
  });
  view.hbb(p_3, view_3);
  view.lbb(tmp_9, view_3);
  var tmp_12 = view.kbb(weight(view, weights.vhx_1), get_centered(view));
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (TextView())(view.pc());
  var tmp0_elvis_lhs_4 = view.ebb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view : tmp0_elvis_lhs_4;
  view.gbb(p_4, view_4);
  view_4.lba(view_4.qb6_1.abf(BodySemantic_getInstance()));
  var status = remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp;
    if ($this$remember.daj(scopeView).g99()) {
      var tmp0 = $this$remember.daj(items);
      var tmp$ret$36;
      $l$block_0: {
        // Inline function 'kotlin.collections.minByOrNull' call
        var iterator = tmp0.m1();
        if (!iterator.n1()) {
          tmp$ret$36 = null;
          break $l$block_0;
        }
        var minElem = iterator.o1();
        if (!iterator.n1()) {
          tmp$ret$36 = minElem;
          break $l$block_0;
        }
        var minValue = minElem.mfy();
        do {
          var e = iterator.o1();
          var v = e.mfy();
          if (compareTo(minValue, v) > 0) {
            minElem = e;
            minValue = v;
          }
        }
         while (iterator.n1());
        tmp$ret$36 = minElem;
      }
      var tmp0_safe_receiver = tmp$ret$36;
      tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.mfy();
    } else {
      tmp = null;
    }
    return tmp;
  });
  dynamicTheme(view_4, ($this$dynamicTheme) => {
    var tmp0_safe_receiver = $this$dynamicTheme.daj(status);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = LineItemStateSemantic(tmp0_safe_receiver);
    }
    return tmp;
  });
  view_4.dbs(Align_Center_getInstance());
  var tmp_13 = KMutableProperty0();
  var tmp_14 = TextView$_get_content_$ref_4pzcwl_5(view_4);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('content', 0, tmp_13, tmp_14, TextView$_set_content_$ref_pketfb_5(view_4));
  reactiveScope(view_4, ($this$reactiveScope) => {
    var tmp0_safe_receiver = $this$reactiveScope.daj(status);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l9b_1;
    var tmp$ret$41 = tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs;
    this_2.set(tmp$ret$41);
    return Unit_instance;
  });
  view.hbb(p_4, view_4);
  view.lbb(tmp_12, view_4);
  var tmp_15 = weight(view, weights.whx_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_5 = new (Frame())(view.pc());
  var tmp0_elvis_lhs_5 = view.ebb_1;
  var p_5 = tmp0_elvis_lhs_5 == null ? view : tmp0_elvis_lhs_5;
  view.gbb(p_5, view_5);
  var tmp_16 = view_5.kbb(shownWhen(view_5, VOID, ($this$shownWhen) => $this$shownWhen.daj(scopeView).g99()), get_centered(view_5));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_6 = new (RowOrCol())(view_5.pc());
  var tmp0_elvis_lhs_6 = view_5.ebb_1;
  var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
  view_5.gbb(p_6, view_6);
  view_6.zbm(false);
  var example = get_waitForNotNull(lens(items, workItemTableSummary$lambda));
  var tmp_17 = get_centered(view_6);
  view_6.lbb(tmp_17, escalationIcon(view_6, remember(VOID, VOID, VOID, ($this$remember) => {
    var tmp0_safe_receiver = $this$remember.daj(_this__u8e3s4.ogf()).p3($this$remember.daj(example).mf9_1);
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.l8w();
  })));
  view_6.lbb(get_centered(view_6), timerRunningIcon(_this__u8e3s4, view_6, example));
  view_5.hbb(p_6, view_6);
  view_5.lbb(tmp_16, view_6);
  view.hbb(p_5, view_5);
  view.lbb(tmp_15, view_5);
  writer.hbb(p, view);
  return writer.lbb(tmp, view);
}
function workItemTableRow$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$status_obexfr(_this__u8e3s4) {
  return !(_this__u8e3s4.g99() == null) ? null : displayState(_this__u8e3s4);
}
function IconView$_get_dragData_$ref_4jg2ny(p0) {
  return () => p0.jb9();
}
function IconView$_set_dragData_$ref_k36t82(p0) {
  return (_this__u8e3s4) => {
    p0.ib9(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_2(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function IconView$_get_shown_$ref_js8irt(p0) {
  return () => p0.yb8();
}
function IconView$_set_shown_$ref_9ilxmr(p0) {
  return (_this__u8e3s4) => {
    p0.jb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_3(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_3(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_4(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_4(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_5(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.vb5_1.lb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_5(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.vb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.hbu(tmp_0);
    return Unit_instance;
  };
}
function workItemTableSummary$lambda(it) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.minByOrNull' call
    var iterator = it.m1();
    if (!iterator.n1()) {
      tmp$ret$0 = null;
      break $l$block_0;
    }
    var minElem = iterator.o1();
    if (!iterator.n1()) {
      tmp$ret$0 = minElem;
      break $l$block_0;
    }
    var minValue = minElem.mfy();
    do {
      var e = iterator.o1();
      var v = e.mfy();
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.n1());
    tmp$ret$0 = minElem;
  }
  return tmp$ret$0;
}
//region block: exports
export {
  WorkItemWeights as WorkItemWeights1puyl4v7xr6t7,
  workItemTableHeader as workItemTableHeader1i5k4rlwsgce6,
  workItemTableRow as workItemTableRow1fg7z95rbicqi,
  workItemTableSummary as workItemTableSummary2lie214j07e5o,
};
//endregion

//# sourceMappingURL=tables.mjs.map
